import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MessageComponent } from '../shared/modal/message/message.component';
import { BasicQuestionComponent } from '../shared/modal/basic-question/basic-question.component';
import { GlobalService } from '../services/global.service';
//import { DOCUMENT } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-integrations',
  templateUrl: './integrations.component.html',
  styleUrls: ['./integrations.component.css']
})

export class IntegrationsComponent implements OnInit {
  cookieValue;
  crmIntegrations;
  crmConnected: boolean = false;

  private navCards = [
    { title: 'Wealthbox', description: 'Connect HVS Portal clients to contacts.', 
        icon: 'fa-bar-chart', color: '#fff', iconColor: '#9578E3', image: 'https://www.wealthbox.com/wp-content/uploads/2023/06/Wealthbox-icon-blue.png', isCreateClient: true, isValidated: false},
    { title: 'Salesforce', description: 'Connect HVS Portal clients to contacts.', 
        icon: 'fa-user-plus', color: '#fff', iconColor: '#3385C5', image: 'https://upload.wikimedia.org/wikipedia/commons/f/f9/Salesforce.com_logo.svg', isCreateClient: true, 
        isDisabled: true, isValidated: false },
    { title: 'Redtail', description: 'Connect HVS Portal clients to contacts.', 
        icon: 'fa-refresh', color: '#fff', iconColor: '#2CBFBB', image: 'https://assets-developers.ringcentral.com/app/logo/88DWlp6XQ7eS48OwbMYsVw~6VK3QxuiM7qbhPJNU9zwMw/47944329-aa8a-44c6-9b3a-8fbe8a504a56.png', isCreateClient: true, 
        isDisabled: true, isValidated: false }    
  ]
  
  constructor(public matDialog: MatDialog, private global: GlobalService, private route: ActivatedRoute) {
    this.crmIntegrations = JSON.parse(localStorage.getItem('crmIntegrations'));

    this.navCards[0].isValidated = this.crmIntegrations.Wealthbox;
    this.crmConnected = this.crmIntegrations.Wealthbox;
    console.log('navCards', this.navCards);
   }

  ngOnInit() {
    if(window.location.href.indexOf("access") > -1){
      //set/get cookie
      this.route.queryParamMap.subscribe((params) => {
        //reset the crmIntegrations storage
        //this.crmIntegrations = JSON.parse(localStorage.getItem('crmIntegrations'));
        this.crmIntegrations.Wealthbox = true;

        //this.crmIntegrations["Wealthbox"] = true;
        this.navCards[0].isValidated = this.crmIntegrations.Wealthbox;
        this.crmConnected = this.crmIntegrations.Wealthbox;
        localStorage.setItem('crmIntegrations', JSON.stringify(this.crmIntegrations));

        //console.log('crmIntegrations', this.crmIntegrations);
        //console.log('navCards', this.navCards);

        //make test API call
        /* this.global.wealthBoxIntegrationTest(params.get('access'))
        .subscribe(
          resp => {
            console.log('wealthbox obj', resp);
          }); */
      });
      
    }
  }

  openModal(comingSoon: boolean = false, isValidated: boolean = false){
    if(comingSoon){
      const dialogRef = this.matDialog.open(MessageComponent, {     
        data: { title: 'Coming soon', message: '' }
      });
      
    } else{
      
      if(!isValidated){
        window.open(this.global.env + 'OAuth/authorize', '_SELF');
      } else {
        //dont allow to re-authenticate right now unless wanted
        const dialogRef = this.matDialog.open(BasicQuestionComponent, {     
            data: { title: 'Notification', question: 'This CRM is already connected to your account. Did you wanna remove this CRM connection?', btnYesTitle: 'Yes, remove connection' }
          });
      
          dialogRef.afterClosed().subscribe(result => {
            if(result){
              //reauthenticate
              //window.open(this.global.env + 'OAuth/authorize', '_SELF');

              //remove wealthbox config
              this.crmIntegrations.Wealthbox = false;
              this.navCards[0].isValidated = this.crmIntegrations.Wealthbox;
              this.crmConnected = this.crmIntegrations.Wealthbox;
              localStorage.setItem('crmIntegrations', JSON.stringify(this.crmIntegrations));

              //TODO: call API to destroy cookie if in here...
            }
          });
        }
    }
  }

}
